import { useState } from "react";

import { Stack } from "@mui/material";

import ActionButtons from "./ActionButtons";
import EndLessonDialog from "./EndLessonDialog";
import CancelLessonDialog from "./features/CancelLessonDialog";

interface Props {
  lessonInfo: any;
  lessonId: string;
  onLessonEnd: () => void;
  onProceed: () => void;
  isSandbox?: boolean;
}

function HeaderActions({
  lessonInfo,
  lessonId,
  onLessonEnd,
  onProceed,
  isSandbox = false,
}: Props) {
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isEndLessonDialogOpen, setIsEndDialogOpen] = useState(false);

  if (!lessonInfo || !lessonId) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <CancelLessonDialog
        isOpen={isCancelDialogOpen}
        onClose={() => setIsCancelDialogOpen(false)}
      />

      <EndLessonDialog
        open={isEndLessonDialogOpen}
        onClose={() => setIsEndDialogOpen(false)}
        onConfirm={onLessonEnd}
      />

      <ActionButtons
        onCancel={() => setIsCancelDialogOpen(true)}
        lessonInfo={lessonInfo}
        onProceed={onProceed}
        onEndLesson={() => setIsEndDialogOpen(true)}
        isSandbox={isSandbox}
      />
    </Stack>
  );
}

export default HeaderActions;
